import { useTranslation } from 'react-i18next';
import { ShareDeviceDialogBase } from './ShareDeviceDialogBase';

interface ShareDeviceConfirmEmailDialogContentProps {
  email: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const ShareDeviceConfirmEmailDialogContent = ({
  email,
  onClose,
  onConfirm,
}: ShareDeviceConfirmEmailDialogContentProps) => {
  const { t } = useTranslation();

  return (
    <ShareDeviceDialogBase onClose={onClose} showCloseButton>
      <div className="dialog__text">
        <p className="dialog__text-line dialog__text-line-mail">{email}</p>
        <p className="dialog__text-line">{t('shareDevice.confirmEmail.message')}</p>
      </div>
      <div className="f4__actions">
        <button className="dialog__btn dialog__btn--send" type="button" onClick={onConfirm}>
          {t('shareDevice.confirmEmail.sendButton')}
        </button>
      </div>
    </ShareDeviceDialogBase>
  );
};
